import { Link } from 'react-router-dom'
import { Banknote, ChevronRight } from 'lucide-react'
import { useStoreOwner } from '../store/useStoreOwner'
import { useStaffAuth } from '../store/useStaffAuth'
import { useI18n } from '../i18n/useI18n'

/**
 * #1431 「現金のみで運用中」の常時バナー。
 *
 * KYC を理由に店舗が入口で止まるのを避けるため現金のみで始められるようにしたが、
 * **KYC を諦めてもらうのが目的ではない**。カード決済 (= 手数料) へ移ってもらう
 * 導線を出し続ける。
 *
 * スタッフには出さない — 本人確認はオーナーの手続きで、バイトが押せる話ではない。
 */
export default function CashOnlyOwnerBanner() {
  const cashOnlyOwner = useStoreOwner((s) => s.cashOnlyOwner)
  const staffSession = useStaffAuth((s) => s.session)
  const { t } = useI18n()

  if (!cashOnlyOwner || staffSession) return null

  return (
    <Link
      to="/store/onboarding"
      className="tap-effect flex items-center gap-2 border-b border-gold/30 bg-gold/10 px-4 py-2"
    >
      <Banknote size={16} className="shrink-0 text-gold" />
      <span className="flex-1 font-body text-xs text-text-secondary">
        <span className="font-semibold text-text-primary">
          {t('storeOnboarding.cashOnlyBanner')}
        </span>
        {' — '}
        {t('storeOnboarding.cashOnlyBannerCta')}
      </span>
      <ChevronRight size={14} className="shrink-0 text-text-tertiary" />
    </Link>
  )
}
